import React, { useContext } from 'react';
import { getAppEnv } from '../../../../config/env';
import { cabsLandingWidgetInfo } from '../../../cabsLandingWidgetInfo';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { SET_WIDGET } from '../cabsLandingPageState';
import { MOB_CABS_LANDING_HR_PACKAGE_TYPE_CLICK } from '../../../constants/omnitureConstants';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const RentalPackageInput = ({ widgetComponent }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);
  const { trackTemplateEvent } = cabsLandingContext;

  const { selectedHrPackage, widget } = cabsLandingContext;
  const widgetNumber = cabsLandingWidgetInfo.HR_PACKAGES_WIDGET;

  const setWidget = widgetNumber => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };
  return (
    <>
      <div id="rental_packages">
        <div
          style={{
            backgroundColor: 'rgb(247, 247, 247)',
            marginTop: '10px',
            border: '1px solid rgb(231, 231, 231)'
          }}
          className="cabsLandingRsw rsw"
        >
          <div
            onClick={() => {
              setWidget(widgetNumber);
              trackTemplateEvent(MOB_CABS_LANDING_HR_PACKAGE_TYPE_CLICK);
            }}
            className="fullWidth"
          >
            <div className="makeFlex alignCenter">
              <img
                className="appendRight10"
                src={`${PUBLIC_URL}/static/public/clock_outline_gray.webp`}
                height={'24px'}
                width={'24px'}
                alt="logo"
              />
              <div>
                <div
                  style={{ color: 'rgb(155, 155, 155)' }}
                  className="font11 latoBold"
                >
                  SELECT PACKAGE
                </div>
                <div className="latoBlack blackText">
                  {selectedHrPackage
                    ? `${selectedHrPackage.time} Hrs ${selectedHrPackage.distance} Kms`
                    : ``}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {widget == cabsLandingWidgetInfo.HR_PACKAGES_WIDGET && widgetComponent}
    </>
  );
};
